import * as Bixby from '$/core';
import { CacheService } from '$/services';

export abstract class CovenantReviewQuickFilterTypeService {
  private static baseUrl = `${Bixby.Constants.API_COVENANTREVIEWQUICKFILTERTYPECONTROLLER}`;
  private static readonly staticDataTimeoutMinutes: number = 7 * 24 * 60;

  public static async getAll(): Promise<Bixby.Models.IIdentifiable[]> {
    const url = `${CovenantReviewQuickFilterTypeService.baseUrl}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await CacheService.getOrSetAsync<Bixby.Models.IIdentifiable[]>(
      Bixby.Constants.CACHE_STATIC_COVENANT_REVIEW_QUICK_FILTER_TYPES,
      () => Bixby.API.get(route),
      CovenantReviewQuickFilterTypeService.staticDataTimeoutMinutes
    );
  }
}
